/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ActorDefs from "../../app/bsky/actor/defs.defs.js";

const $nsid = "place.stream.getLikes";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"subject":/*#__PURE__*/ l.string({"format":"at-uri"}),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 50))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"subject":/*#__PURE__*/ l.string({"format":"at-uri"}),"count":/*#__PURE__*/ l.integer({"minimum":0}),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"likes":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<LikeView>((() => likeView) as any), ))});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get likes for a subject (video or comment). */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;

type LikeView = { $type?: "place.stream.getLikes#likeView";"uri":l.AtUriString;"cid":l.CidString;"author":ActorDefs.ProfileViewBasic;"record":l.LexMap;"indexedAt":l.DatetimeString };

export type { LikeView };

const likeView = /*#__PURE__*/ l.typedObject<LikeView>($nsid, "likeView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"}),"author":/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any),"record":/*#__PURE__*/ l.lexMap(),"indexedAt":/*#__PURE__*/ l.string({"format":"datetime"})}));

export { likeView };
